export const LOCALE_STORAGE_KEY = 'heysens-locale';
export const DEFAULT_LOCALE = 'zh';
export const SUPPORTED_LOCALES = ['zh', 'vi'];

export function normalizeLocale(locale) {
	if (!locale || typeof locale !== 'string') {
		return null;
	}

	const normalized = locale.toLowerCase();

	if (normalized.startsWith('zh')) {
		return 'zh';
	}

	if (normalized.startsWith('vi')) {
		return 'vi';
	}

	return null;
}

export function getSavedLocale() {
	if (typeof window === 'undefined' || !window.localStorage) {
		return null;
	}

	return normalizeLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY));
}

export function saveLocale(locale) {
	const normalized = normalizeLocale(locale);

	if (!normalized || typeof window === 'undefined' || !window.localStorage) {
		return null;
	}

	window.localStorage.setItem(LOCALE_STORAGE_KEY, normalized);

	return normalized;
}

export function getBrowserLocale() {
	if (typeof navigator === 'undefined') {
		return null;
	}

	return normalizeLocale(navigator.language || navigator.userLanguage || '');
}

export function resolveInitialLocale() {
	return getSavedLocale() || getBrowserLocale() || DEFAULT_LOCALE;
}

export function setDocumentLocale(locale) {
	if (typeof document === 'undefined') {
		return;
	}

	document.documentElement.setAttribute('lang', normalizeLocale(locale) || DEFAULT_LOCALE);
	}
